<script lang="ts">
	import { storyblokEditable } from '@storyblok/svelte';
	import AdaptiveImage from '$lib/components/AdaptiveImage.svelte';
	import TabletSwipeableWrapper from '@app/components/layouts/TabletSwipeableWrapper.svelte';
	import { getOptimizedCmsImageUrl } from '@app/utils/cms.js';
	import LandingPageSectionTitles from '@app/components/cms/landing-pages/LandingPageSectionTitles.svelte';
	import TestimonyLandingPage from '@app/components/cms/landing-pages/TestimonyLandingPage.svelte';

	export let blok;
</script>

<div use:storyblokEditable={blok}>
	<div class="bg-text py-[64px] lg:py-[80px]">
		<div class="container relative">
			<div
				class="hidden xl:block font-display font-bold text-grey-darker text-[608px] absolute -top-[120px] left-[30px]"
			>
				"
			</div>
			<div class="text-white relative">
				<LandingPageSectionTitles {blok} />
			</div>

			<TabletSwipeableWrapper
				classNames="flex gap-3 pt-6 lg:grid lg:grid-cols-3 relative max-w-[1300px] lg:!m-auto"
			>
				{#each blok.testimonies as t}
					<TestimonyLandingPage props={t} classNames="w-10/12 md:w-2/5 lg:w-auto flex-shrink-0" />
				{/each}
			</TabletSwipeableWrapper>
		</div>
	</div>
	<div class="bg-grey-darker py-5 lg:py-6">
		<div class="container">
			<TabletSwipeableWrapper classNames="flex items-center justify-between gap-4">
				<div class="text-xl lg:text-[28px] font-semibold text-dashboardBg flex-shrink-0">
					{blok.referencesTitle}
				</div>
				{#each blok.references as ref}
					<AdaptiveImage
						src={getOptimizedCmsImageUrl(ref.filename, '0x32')}
						classNames="brightness-0 invert"
					/>
				{/each}
			</TabletSwipeableWrapper>
		</div>
	</div>
</div>
